<template>
    <div>
        <p class="font-weight-bold"> Documents </p>
        <div class="row text-small text-center">
            <div class="col-sm-12">
                <table class="table table-sm table-hover border" id="documentsTable">
                    <thead class="bg-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Document Name</th>
                        <th scope="col">Uploaded By</th>
                        <th scope="col">Updated At</th>
                        <th scope="col">Type</th>
                        <th scope="col">Size</th>
                        <th scope="col">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="row" class="align-middle">1</th>
                        <td class="align-middle">ACCREDITATION CERTIFICATE</td>
                        <td class="align-middle">Candice Cooper</td>
                        <td class="align-middle">30-May-17</td>
                        <td class="align-middle">PDF</td>
                        <td class="align-middle">1.3mb</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-file-download"></i>
                                Download
                            </button>
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">2</th>
                        <td class="align-middle">CERTIFICATE OF COVER</td>
                        <td class="align-middle">Bert Young</td>
                        <td class="align-middle">11-Aug-12</td>
                        <td class="align-middle">Word</td>
                        <td class="align-middle">300kb</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-file-download"></i>
                                Download
                            </button>
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">3</th>
                        <td class="align-middle">COLLECTIVE BARGAINING AGREEMENT</td>
                        <td class="align-middle">Christine Fisher</td>
                        <td class="align-middle">19-Oct-15</td>
                        <td class="align-middle">PDF</td>
                        <td class="align-middle">2.1mb</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-file-download"></i>
                                Download
                            </button>
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">4</th>
                        <td class="align-middle">FLAG REGISTRY</td>
                        <td class="align-middle">Candice Cooper</td>
                        <td class="align-middle">30-May-17</td>
                        <td class="align-middle">PDF</td>
                        <td class="align-middle">1.3mb</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-file-download"></i>
                                Download
                            </button>
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">5</th>
                        <td class="align-middle">FOUR PARTIES AGREEMENT</td>
                        <td class="align-middle">Bert Young</td>
                        <td class="align-middle">11-Aug-12</td>
                        <td class="align-middle">Word</td>
                        <td class="align-middle">300kb</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-file-download"></i>
                                Download
                            </button>
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">6</th>
                        <td class="align-middle">GREEN CERTIFICATE / BLUE CERTIFICATE / LETTER OF CONFIRMATION (JAP FLAG)</td>
                        <td class="align-middle">Christine Fisher</td>
                        <td class="align-middle">19-Oct-15</td>
                        <td class="align-middle">PDF</td>
                        <td class="align-middle">2.1mb</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-file-download"></i>
                                Download
                            </button>
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">7</th>
                        <td class="align-middle">MINIMUM SAFE MANNING DOCUMENT</td>
                        <td class="align-middle">Candice Cooper</td>
                        <td class="align-middle">30-May-17</td>
                        <td class="align-middle">PDF</td>
                        <td class="align-middle">1.3mb</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-file-download"></i>
                                Download
                            </button>
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">8</th>
                        <td class="align-middle">SUPPLEMENTARY AGREEMENT</td>
                        <td class="align-middle">Bert Young</td>
                        <td class="align-middle">11-Aug-12</td>
                        <td class="align-middle">Word</td>
                        <td class="align-middle">300kb</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-file-download"></i>
                                Download
                            </button>
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">9</th>
                        <td class="align-middle">VESSEL PARTICULARS</td>
                        <td class="align-middle">Christine Fisher</td>
                        <td class="align-middle">19-Oct-15</td>
                        <td class="align-middle">PDF</td>
                        <td class="align-middle">2.1mb</td>
                        <td class="align-middle">
                            <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-file-download"></i>
                                Download
                            </button>
                            <button class="btn btn-xs btn-outline-primary px-2 mr-1" disabled
                                    title="Print Crew Result">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { vueAppMixin} from "@/mixins/vueAppMixin";
import { gateMixin} from "@/mixins/gateMixin";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "VesselDocument",
    mixins: [ vueAppMixin, gateMixin],
    methods: {
        ...mapActions([  ]),
    },

    computed: {
        ...mapGetters([ 'vessel' ]),

    },
}
</script>

<style scoped>

</style>
